export default class Message {
  readonly type: string;
  readonly data: any;
  readonly timestamp: string = new Date().toISOString();
  constructor(type: string, data?: any) {
    this.type = type;
    this.data = data || {};
  }

  public isValid() {
    if (!this.type || !this.data) {
      return false;
    }
    return true;
  }

  toJSON() {
    return JSON.stringify({
      type: this.type,
      data: this.data,
      timestamp: this.timestamp,
    });
  }
}
